import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useReactRouter from 'use-react-router';

// Menu for the Civil Conference. `instituteId` prop is used where the route has no :id (e.g. login page).
const CivilConferenceMenu = ({ instituteId }) => {
  const history = useHistory();
  const { match } = useReactRouter();
  const id = match?.params?.id || instituteId || 1;
  const btn = { marginRight: '10px', backgroundColor: '#009688' };

  return (
    <div style={{ display: 'flex', marginBottom: '20px', marginTop: '20px', justifyContent: 'center' }}>
      <Button variant="contained" color="primary" style={btn} onClick={() => history.push(`/civil-conference-form/${id}`)}>Apply</Button>
      <Button variant="contained" color="primary" style={btn} onClick={() => history.push(`/civil-conference-payment/${id}`)}>Payment</Button>
      <Button variant="contained" color="primary" style={btn} onClick={() => history.push(`/civil-conference-download/${id}`)}>Download</Button>
    </div>
  );
};

export default CivilConferenceMenu;
